var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.typeCheck === 'post' && _vm.responseData)?_c('Article',{attrs:{"articleData":_vm.responseData}}):(
    this.typeCheck === 'review' && !this.templateCheck && _vm.responseData
  )?_c('Review',{attrs:{"reviewData":_vm.responseData}}):(
    this.typeCheck === 'review' && this.templateCheck && _vm.responseData
  )?_c('ReviewWithBlocks',{attrs:{"reviewNewData":_vm.responseData}}):(this.typeCheck === 'payment_options' && _vm.responseData)?_c('PaymentOptions',{attrs:{"paymentData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'game-guide-holder' &&
    _vm.responseData
  )?_c('GameGuideHolder',{attrs:{"gameguideholderData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'about-us' &&
    _vm.responseData
  )?_c('AboutUs',{attrs:{"aboutUsData":_vm.responseData}}):(
    (this.typeCheck === 'game_free' || this.typeCheck === 'game_paid') &&
    _vm.responseData
  )?_c('GameFree',{attrs:{"gamesData":_vm.responseData,"gameTemplate":this.typeCheck}}):(
    this.typeCheck === 'page' &&
    (this.templateCheck === 'default-page' || this.templateCheck === '') &&
    _vm.responseData
  )?_c('DefaultPage',{attrs:{"defaultPageData":_vm.responseData}}):(this.typeCheck === 'news' && _vm.responseData)?_c('News',{attrs:{"newsData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'feast-group' &&
    _vm.responseData
  )?_c('CalendarTemplate',{attrs:{"calendarData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'usmap-page' &&
    _vm.responseData
  )?_c('MapTemplate',{attrs:{"mapTemplateData":_vm.responseData}}):(this.typeCheck === 'software_providers' && _vm.responseData)?_c('SoftwareProviders',{attrs:{"softwareProviderData":_vm.responseData}}):(
    (this.typeCheck === 'promotions' ||
      (this.typeCheck === 'page' &&
        this.templateCheck === 'promotions-landing')) &&
    _vm.responseData
  )?_c('Promotions',{attrs:{"promotionData":_vm.responseData}}):(
    this.typeCheck === 'page' &&
    this.templateCheck === 'home-with-default' &&
    _vm.responseData
  )?_c('HomeLayout2',{attrs:{"homeLayout2Data":_vm.responseData}}):(
    this.typeCheck === 'page' && this.templateCheck === '' && _vm.responseData
  )?_c('HomeLayout1',{attrs:{"homeLayout1Data":_vm.responseData}}):(this.typeCheck === 'error')?_c('NotFound'):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55233fdc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Preview.vue
// module id = 702
// module chunks = 1